import { styled } from '@mui/material/styles';
import { get, isEmpty } from 'lodash';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';

import AddressType from './AddressType';
import AddressCharacteristic from './AddressCharacteristic';
import AddressPackagePlacement from './AddressPackagePlacement';
import AddressQuestionnaireButton from './QuestionnaireButton';
import { QUESTIONNAIRE_PROPERTIES } from 'constants/common';
import useSearchParams from 'hooks/useSearchParams';

const PREFIX = 'AddressQuestionnaire';

const classes = {
  root: `${PREFIX}-root`,
  heading: `${PREFIX}-heading`,
  text: `${PREFIX}-text`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    marginBottom: '1rem',
  },

  [`& .${classes.heading}`]: {
    textDecoration: 'underline',
    display: 'flex',
    alignItems: 'center',
    margin: '0 0 0.5rem 0',
    color: theme.colorTokens.onSurfaceTextHeadline,
    fontWeight: 500,
  },

  [`& .${classes.text}`]: {
    color: theme.colorTokens.onSurfaceTextBody,
    fontSize: '14px',
  },
}));

export const AddressQuestionnaire = compose(
  inject('store'),
  observer,
)((props) => {
  const [searchParams] = useSearchParams();

  const { store } = props;
  const { deliveryStore } = store;
  const { delivery } = deliveryStore;
  const questionnaire = get(delivery, 'recipient-questionnaire');
  const doing = typeof questionnaire === 'object' && QUESTIONNAIRE_PROPERTIES.some((property) => questionnaire.hasOwnProperty(property));
  const skip = searchParams.get('skip_questionnaire');

  const skipStatuses = ['skippable'];
  const show = (isEmpty(questionnaire) && (isEmpty(skip) || skip !== 'skipped')) || skipStatuses.includes(skip) || doing;

  if (!delivery) return null;

  return (
    <Root className={classes.root}>
      <h3 className={classes.heading}>Address Questionnaire {show ? <ArrowDropDown /> : <ArrowDropUp />}</h3>
      <p className={classes.text}>
        {doing || skip === 'skippable'
          ? 'Please complete before going to Delivery Details.'
          : 'Please complete this short form to proceed to update delivery details.'}
      </p>
      {show && (
        <>
          <AddressType />
          <AddressCharacteristic />
          <AddressPackagePlacement />
        </>
      )}
      <AddressQuestionnaireButton />
    </Root>
  );
});
